/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseTermsContent } from '../models/ApiResponseTermsContent';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TermsContentsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 약관내용 조회
   * 약관내용 조회
   * @returns ApiResponseTermsContent OK
   * @throws ApiError
   */
  public supportedSelectiveTermsContents({
    termscode,
    acceptLanguage,
  }: {
    termscode: 'DI' | 'SAFETY_SCORE' | 'UBI',
    acceptLanguage?: string,
  }): CancelablePromise<ApiResponseTermsContent> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/terms/{termscode}/contents',
      path: {
        'termscode': termscode,
      },
      headers: {
        'Accept-Language': acceptLanguage,
      },
    });
  }
}
